import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { Dispatch } from 'redux';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';
import { Tag } from '@synergy/models';

import { Api } from '../../api';
import { AppState } from '../../store/models/app-state';
import { ConfigurationTag } from '../../features/configuration/data/tags/models/configuration-tag';

export const CANCEL_DEMAND_TAGS_REQUEST = 'CANCEL_DEMAND_TAGS_REQUEST';
export const CANCEL_TAGS_REQUEST = 'CANCEL_TAGS_REQUEST';
export const CONFIGURATION_TAG_CREATED = 'CONFIGURATION_TAG_CREATED';
export const CONFIGURATION_TAG_DELETED = 'CONFIGURATION_TAG_DELETED';
export const CONFIGURATION_TAG_UPDATED = 'CONFIGURATION_TAG_UPDATED';
export const CONFIGURATION_TAGS_RECEIVED = 'CONFIGURATION_TAGS_RECEIVED';
export const CONFIGURATION_TAGS_REQUEST_CANCELED = 'CONFIGURATION_TAGS_REQUEST_CANCELED';
export const CONFIGURATION_TAGS_REQUESTED = 'CONFIGURATION_TAGS_REQUESTED';
export const RECEIVE_DEMAND_TAGS = 'RECEIVE_DEMAND_TAGS';
export const RECEIVE_TAGS = 'RECEIVE_TAGS';
export const REQUEST_DEMAND_TAGS = 'REQUEST_DEMAND_TAGS';
export const REQUEST_TAGS = 'REQUEST_TAGS';

const requestDemandTags = () => {
    return {
        type: REQUEST_DEMAND_TAGS,
    };
};

const requestTags = () => {
    return {
        type: REQUEST_TAGS,
    };
};

const receiveDemandTags = (tags: Tag[]) => {
    return {
        type: RECEIVE_DEMAND_TAGS,
        tags,
    };
};

const receiveTags = (tags: Tag[]) => {
    return {
        type: RECEIVE_TAGS,
        tags,
    };
};

const cancelDemandTagsRequest = () => {
    return {
        type: CANCEL_DEMAND_TAGS_REQUEST,
    };
};

const cancelTagsRequest = () => {
    return {
        type: CANCEL_TAGS_REQUEST,
    };
};

export const fetchDemandTags = () => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch(requestDemandTags());
        const response = await api.tag.getAll(new URLSearchParams({ prefix: 'BE' }));

        if (response.success) {
            dispatch(receiveDemandTags(response.result));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
            dispatch(cancelDemandTagsRequest());
        }
    };
};

export const fetchTags = () => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch(requestTags());
        const response = await api.tag.getAll();

        if (response.success) {
            dispatch(receiveTags(response.result));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
            dispatch(cancelTagsRequest());
        }
    };
};

export const fetchConfigurationTags = (searchParams: URLSearchParams) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: CONFIGURATION_TAGS_REQUESTED });

        const response = await api.tag.getAllConfigurationTags(searchParams);

        if (response.success) {
            dispatch({ type: CONFIGURATION_TAGS_RECEIVED, configurationTags: response.result });
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
            dispatch({ type: CONFIGURATION_TAGS_REQUEST_CANCELED });
        }
    };
};

export const updateConfigurationTag = (tag: Partial<ConfigurationTag>) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: CONFIGURATION_TAG_UPDATED, tag });
        if (!tag.id) {
            return;
        }

        const response = await api.tag.updateConfigurationTag(tag.id, tag);

        if (response.success) {
            dispatch(Snackbar.enqueue(PoolNotification.success('app.snackbar.tagUpdated')));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const createConfigurationTag = (tag: Partial<ConfigurationTag>) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        const response = await api.tag.post(tag);

        if (response.success) {
            dispatch({ type: CONFIGURATION_TAG_CREATED, configurationTag: response.result });
            dispatch(Snackbar.enqueue(PoolNotification.success('app.snackbar.tagCreated')));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};

export const deleteConfigurationTag = (id: number) => {
    return async (dispatch: Dispatch, _getState: () => AppState, { api }: { api: Api }) => {
        dispatch({ type: CONFIGURATION_TAG_DELETED, id });
        const response = await api.tag.deleteConfigurationTag(id);

        if (response.success) {
            dispatch(Snackbar.enqueue(PoolNotification.success('app.snackbar.tagDeleted')));
        } else {
            dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));
        }
    };
};
